import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import ConfirmOrderFeedback from "components/organisms/employee-orders/confirm-order-feedback/ConfirmOrderFeedback";
import IconButton from "components/atoms/button/IconButton";
import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";
import { usePermissions } from "lib/hooks/shared/usePermissions";


export const orderRequestsAdminHeaders = [
    {
        id: 1,
        Header: "ID",
        accessor: "id",
        isChecked: true
    },
    {
        id: 2,
        Header: "Product Name",
        accessor: "product_name",
        isChecked: true
    },
    {
        id: 3,
        Header: "Date",
       accessor: (row: any) => new Date(row?.created_at),
        Cell: ({ row }: any) => {
            return (
                new Date(row.original.created_at).toLocaleDateString("de")
            );
        },
        isChecked: true
    },
    {
        id: 4,
        Header: "Commment",
        accessor: "comment",
        isChecked: true
    },
    {
        id: 5,
        Header: "Status",
        accessor: "status",
        Cell: ({ row }: any) => {
            return (
                <Status value={row.original.status} />
            );
        },
        isChecked: true
    },
    {
        Header: "",
        accessor: "actions",
        id: 'action_buttons',
        Cell: ({ row }: any) => (
            <ActionButton
                value={row.original.status}
                original={row.original}
            />
        ),
        isChecked: true
    }

];

const ActionButton = ({ original }: any) => {

    const [ModalData, setModalData] = useState('')

    return (
        <div className="flex flex-row items-center w-fit gap-4">
            <ConditionalRender condition={usePermissions(['orders_request_feedback'])}>
                <IconButton className="min-w-[120px] !py-[6px]" secondary onClick={() => {
                    setModalData('rejected')
                }}>
                    Reject
                </IconButton>
                <IconButton className="min-w-[120px] !py-[6px]" onClick={() => {
                    setModalData('approved')
                }}>
                    Approve
                </IconButton>
            </ConditionalRender>

            <ConfirmOrderFeedback
                hocCurrentStep={1}
                hocTitle={ModalData === 'approved' ? `Approve order` : `Reject order`}
                hocisOpen={ModalData !== ''}
                hocToggleModal={() => {
                    setModalData('')
                }}
                hocClasses={{
                    modalClassName: 'w-full sm:max-w-[500px]',
                }}
                data={{ status: ModalData, order_id: original.id }}
            />
        </div>
    );
};

const Status = ({ value }: any) => {
    const [Color, setColor] = useState<string>("");
    const { t } = useTranslation();


    useEffect(() => {
        switch (value) {
            case 'pending':
                setColor("#EFBE12");
                break;

            case 'accepted':
                setColor("#2DE28B");
                break;
            case 'refused':
                setColor("#CC7272");
                break;
        }

    }, [value, t]);

    const CapitalizedValue = useMemo(() => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }, [value])

    return (
        <span
            className={`text-[12px] bg-opacity-10 font-inter-light px-[8px] py-[3px] rounded-[4px] whitespace-nowrap`}
            style={{ background: Color + "1A", color: Color }}
        >
            {t(CapitalizedValue)}
        </span>
    );
};
